module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('f7-popover', {
    staticClass: "popoverInbox"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("1. Click on the bottom button to create a new payments request.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("2. Click on payments requests in the list to see more details and to reply the request.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("3. Swipe payment request to left to see more actions.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverSendbox"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("1. Click on the bottom button to create a new payments request.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("2. Click on payments requests in the list to see more details and to reply the request.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("3. Swipe payment request to left to see more actions.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverAttachments"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("1. Click on the bottom left button to import an attachment from your computer.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("2. Click on the bottom middle button to create an invoice.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("3. Click on the bottom right button to create a refund.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("4. Click on attachments in the list to see more details.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("5. Swipe attachments to left to see more actions.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverAccounts"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("1. Click on accounts in the list to switch account.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("2. Swipe account to left to see more actions.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverBanks"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("1. Click on the bottom button to add new bank account.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("2. Click on bank accounts in the list to see more details.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverContacts"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("1. Click on the bottom button to create a new contact.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("2. Click on contacts in the list to see more details.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("3. Swipe contact to left to see more actions.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverPilotage"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("This page is used for showing your recent operations.")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverDashboard"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("User Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_vm._v("Application dashboard")])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverMembers"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("Access Rights Guide")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('b', [_vm._v("No Access:")]), _vm._v(" the member won't have access to the service.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('b', [_vm._v("User:")]), _vm._v(" the member can access the service and use it.")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('b', [_vm._v("Administrator:")]), _vm._v(" the member will be able to:\n      "), _c('ul', [_c('li', [_vm._v("Access the service and use it.")]), _vm._v(" "), _c('li', [_vm._v("Manage the hierarchy of the organization (add members and manage all the teams).")]), _vm._v(" "), _c('li', [_vm._v("Remove payments or requests from the lists according to the selected service. ")])])])])]), _vm._v(" "), _c('f7-popover', {
    staticClass: "popoverReportDP"
  }, [_c('div', {
    staticClass: "infoPopoverContainer"
  }, [_c('p', {
    staticClass: "infoPopoverTitle"
  }, [_vm._v("Status Indicators")]), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check",
      "color": "green"
    }
  }), _vm._v(" The direct payment was created successfully.")], 1), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('f7-icon', {
    attrs: {
      "fa": "close",
      "color": "red"
    }
  }), _vm._v(" Error : the direct payment was not created.")], 1), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('f7-icon', {
    attrs: {
      "fa": "exclamation-triangle",
      "color": "yellow"
    }
  }), _vm._v(" Sender bank account is not linked to this account. Direct payment was not created.")], 1), _vm._v(" "), _c('p', {
    staticClass: "infoPopoverParagraph"
  }, [_c('f7-icon', {
    attrs: {
      "fa": "refresh",
      "color": "black"
    }
  }), _vm._v(" Processing...")], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-daf888dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daf888dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/userGuidePopovers.vue
// module id = 2513
// module chunks = 2